import { Group, Text } from "@mantine/core"
import type { ReactNode } from "react"

export function SectionHeader({
  title,
  description,
  actions,
}: {
  title: string
  description?: string
  actions?: ReactNode
}) {
  return (
    <Group justify="space-between" align="flex-start" gap="md">
      <div>
        <Text component="h2" fw={700} size="lg">
          {title}
        </Text>
        {description ? (
          <Text c="dimmed" size="sm">
            {description}
          </Text>
        ) : null}
      </div>
      {actions ? <Group gap="xs">{actions}</Group> : null}
    </Group>
  )
}
